import { useNavigate } from "react-router-dom";
import YildizArkaplan from "../components/YildizArkaplan";
import { useFal } from "../context/FalContext";
import { FALCILAR } from "../data/falcilar";
import { useTranslation } from "react-i18next";

export default function Fallarim() {
  const navigate = useNavigate();
  const { fallar, bekleyenFallar, hazirFallar, okunmusFallar } = useFal();
  const { t } = useTranslation();

  const sureFarki = (hazirOlmaZamani) => {
    if (!hazirOlmaZamani) return t("myReadings.timeLeft");
    const fark = Math.max(0, new Date(hazirOlmaZamani) - Date.now());
    const dakika = Math.ceil(fark / 1000 / 60);
    if (dakika <= 0) return t("myReadings.timeLeft");
    return t("myReadings.minutesLeft", { min: dakika });
  };

  const tarihFormat = (zaman) => {
    if (!zaman) return "";
    return new Date(zaman).toLocaleDateString(undefined, {
      day: "numeric", month: "long",
      hour: "2-digit", minute: "2-digit",
    });
  };

  const FAL_EMOJI = { kahve: "☕", el: "✋", yuz: "👤", iliski: "💑" };
  const FAL_ISIM_KEY = { kahve: "readings.coffee", el: "readings.hand", yuz: "readings.face", iliski: "readings.relationship" };

  const falciBul = (falciId) => {
    return FALCILAR.find((f) => f.id === falciId) || {
      emoji: "🔮", renk: "#6B3FA0", parlak: "#A855F7", isim: "Falcı"
    };
  };

  const FalKarti = ({ fal, tip }) => {
    const falci = falciBul(fal.falci_id);
    return (
      <div
        onClick={() => navigate(`/fal-detay/${fal.id}`)}
        style={{
          background: "rgba(255,255,255,0.04)",
          border: tip === "hazir" ? "1px solid rgba(244,114,182,0.3)" : "1px solid rgba(255,255,255,0.08)",
          borderRadius: 14, padding: "14px 16px",
          marginBottom: 10, cursor: "pointer",
          display: "flex", alignItems: "center",
          justifyContent: "space-between",
          transition: "all 0.2s",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{
            width: 44, height: 44, borderRadius: 12,
            background: `${falci.renk}22`, border: `1px solid ${falci.renk}44`,
            display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20,
          }}>
            {falci.emoji}
          </div>
          <div>
            <div style={{ fontSize: 14, color: "#fff", fontWeight: 600 }}>
              {falci.isim}
            </div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginTop: 2 }}>
              {FAL_EMOJI[fal.fal_turu]} {t(FAL_ISIM_KEY[fal.fal_turu])} · {tarihFormat(fal.created_at)}
            </div>
          </div>
        </div>

        {tip === "bekliyor" && (
          <div style={{
            padding: "4px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600,
            background: "rgba(249,203,66,0.15)", border: "1px solid rgba(249,203,66,0.3)",
            color: "#F9CB42", whiteSpace: "nowrap",
          }}>
            {sureFarki(fal.hazir_olma_zamani)}
          </div>
        )}
        {tip === "hazir" && (
          <div style={{
            padding: "4px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700,
            background: "rgba(244,114,182,0.2)", border: "1px solid rgba(244,114,182,0.4)",
            color: "#F472B6", animation: "nabiz 2s ease-in-out infinite", whiteSpace: "nowrap",
          }}>
            {t("myReadings.statusReady")}
          </div>
        )}
        {tip === "okundu" && (
          <div style={{
            padding: "4px 10px", borderRadius: 20, fontSize: 11,
            background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)",
            color: "rgba(255,255,255,0.35)",
          }}>
            {t("myReadings.statusRead")}
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)",
      position: "relative",
      fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420, margin: "0 auto",
    }}>
      <style>{`
        @keyframes nabiz {
          0%, 100% { opacity: 0.6; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.08); }
        }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      <YildizArkaplan />

      <div style={{ position: "relative", zIndex: 1, paddingBottom: 90 }}>

        {/* Header */}
        <div style={{ padding: "24px 24px 24px" }}>
          <div style={{ fontSize: 26, fontWeight: 800, color: "#fff", fontFamily: "Georgia, serif" }}>
            {t("myReadings.title")}
          </div>
          <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", marginTop: 4 }}>
            {t("myReadings.subtitle")}
          </div>
        </div>

        {/* Özet */}
        <div style={{ padding: "0 24px 24px", display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
          {[
            { label: t("myReadings.waiting"), deger: bekleyenFallar.length, icon: "⏳", renk: "#F9CB42" },
            { label: t("myReadings.ready"), deger: hazirFallar.length, icon: "✨", renk: "#F472B6" },
            { label: t("myReadings.total"), deger: fallar.length, icon: "🔮", renk: "#A855F7" },
          ].map((ozet, i) => (
            <div key={i} style={{
              background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: 14, padding: "14px 12px",
              display: "flex", flexDirection: "column", alignItems: "center", gap: 6,
            }}>
              <div style={{ fontSize: 22 }}>{ozet.icon}</div>
              <div style={{ fontSize: 22, fontWeight: 800, color: ozet.renk }}>{ozet.deger}</div>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}>{ozet.label}</div>
            </div>
          ))}
        </div>

        <div style={{ padding: "0 24px" }}>

          {hazirFallar.length > 0 && (
            <div style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 13, color: "#F472B6", letterSpacing: 2, textTransform: "uppercase", fontWeight: 600, marginBottom: 12 }}>
                {t("myReadings.readySection")}
              </div>
              {hazirFallar.map((fal) => <FalKarti key={fal.id} fal={fal} tip="hazir" />)}
            </div>
          )}

          {bekleyenFallar.length > 0 && (
            <div style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", letterSpacing: 2, textTransform: "uppercase", fontWeight: 600, marginBottom: 12 }}>
                {t("myReadings.waitingSection")}
              </div>
              {bekleyenFallar.map((fal) => <FalKarti key={fal.id} fal={fal} tip="bekliyor" />)}
            </div>
          )}

          {okunmusFallar.length > 0 && (
            <div style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", letterSpacing: 2, textTransform: "uppercase", fontWeight: 600, marginBottom: 12 }}>
                {t("myReadings.pastSection")}
              </div>
              {okunmusFallar.map((fal) => <FalKarti key={fal.id} fal={fal} tip="okundu" />)}
            </div>
          )}

          {fallar.length === 0 && (
            <div style={{ textAlign: "center", padding: "60px 0" }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>🔮</div>
              <div style={{ fontSize: 16, fontWeight: 700, color: "#fff", fontFamily: "Georgia, serif", marginBottom: 8 }}>
                {t("myReadings.empty")}
              </div>
              <div style={{ fontSize: 13, color: "rgba(255,255,255,0.4)", marginBottom: 24 }}>
                {t("myReadings.emptyDesc")}
              </div>
              <button
                onClick={() => navigate("/falcilar")}
                style={{
                  padding: "12px 28px", borderRadius: 14,
                  background: "linear-gradient(135deg, #6B3FA0 0%, #A855F7 100%)",
                  border: "none", color: "#fff", fontSize: 14,
                  fontWeight: 700, cursor: "pointer", fontFamily: "Georgia, serif",
                }}
              >
                {t("myReadings.exploreBtn")}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}